export const ARTICLES_SUBDOMAIN = 'articles'

export const RESERVED_SUBDOMAINS = ['www', 'hapana', ARTICLES_SUBDOMAIN] as const

export const BRAND_HINT_COOKIE = 'hapana_brand'

export const BRAND_HINT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export const BRAND_OVERRIDE_PARAM = 'b'

export const REDIRECT_PARAM = 'redirect'

export const HELP_DOCS_PATH = 'help-docs'

// Matches KnowledgeArticle.slug in shared/schemas/support/knowledge-article-schemas.ts.
export const MAX_ARTICLE_SLUG_LENGTH = 255
